import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { works } from "@/mocks/works";
import { formatNumber } from "@/utils/format";

export default function HotWorks() {
  const hotList = works.filter((w) => w.hot);
  const lead = hotList[0];
  const ranking = works.filter((w) => w.id !== lead.id).slice(0, 5);

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Hot Works"
        title="热门参赛作品"
        desc="根据读者点赞与浏览热度实时排出的参赛作品，本期最受关注的爆料都在这几篇里。"
        linkTo="/works?sort=hot"
        linkLabel="查看热门排行"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <article className="lg:col-span-7 flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-100">
          <Link
            to={`/work/${lead.id}`}
            className="block relative w-full h-[240px] md:h-[320px] bg-background-200"
            aria-label={`阅读作品：${lead.title}`}
          >
            <img src={lead.cover} alt={lead.title} className="w-full h-full object-cover object-top" />
            <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 text-xs text-primary-950 bg-accent-400 px-3 py-1.5 rounded-full">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-trophy-line" />
              </span>
              热度第一
            </span>
          </Link>
          <div className="flex flex-col flex-1 p-5 md:p-7">
            <span className="text-xs text-primary-700">{lead.categoryName}</span>
            <h3 className="mt-2 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
              <Link to={`/work/${lead.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                {lead.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{lead.summary}</p>
            <div className="mt-auto pt-5 flex items-center gap-5 flex-wrap text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-user-3-line" />
                </span>
                {lead.author}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line" />
                </span>
                {formatNumber(lead.likes)} 点赞
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-eye-line" />
                </span>
                {formatNumber(lead.views)} 浏览
              </span>
            </div>
          </div>
        </article>

        <ol className="lg:col-span-5 flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {ranking.map((work, index) => (
            <li key={work.id} className="border-b border-background-200 last:border-b-0">
              <Link
                to={`/work/${work.id}`}
                className="flex items-center gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span
                  className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md font-heading text-sm font-bold ${
                    index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 2}
                </span>
                <span className="relative w-16 h-14 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img src={work.cover} alt={work.title} className="w-full h-full object-cover object-top" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-heading text-sm font-bold text-foreground-950 truncate">
                    {work.title}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    {work.author} · {formatNumber(work.likes)} 点赞
                  </span>
                </span>
                <span className="w-4 h-4 flex items-center justify-center text-foreground-400 shrink-0">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}